import React from 'react'
import styled from 'styled-components'
import { Icon } from '../Icon'

const StyledTh = styled.th``

const Clickable = ({
  onClick,
  ...rest
}: React.ComponentPropsWithoutRef<'button'>) => {
  if (onClick) {
    return <button onClick={onClick} {...rest} />
  }
  return <>{rest.children}</>
}

export type ThProps = React.ComponentPropsWithoutRef<'th'> & {
  sortDirection?: 'asc' | 'desc'
  onClick?: React.MouseEventHandler
}

export const Th = React.forwardRef<HTMLTableCellElement, ThProps>(
  ({ onClick, children, sortDirection, ...rest }, ref) => {
    return (
      <StyledTh ref={ref} role='columnheader' scope='col' {...rest}>
        <Clickable onClick={onClick}>
          {children}
          {sortDirection !== undefined && (
            <Icon
              css='color: var(--gray600); margin-left: 4px;'
              height='14px'
              width='14px'
              type={sortDirection === 'asc' ? 'CHEVRON_UP' : 'CHEVRON_DOWN'}
            />
          )}
        </Clickable>
      </StyledTh>
    )
  }
) 